import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from "@nextui-org/react";
import { FiChevronLeft, FiChevronRight, FiChevronDown } from "react-icons/fi";

const STATUS_LABELS = {
  completed: "Terminé",
  scheduled: "Planifié",
  draft: "Brouillon",
};

// Moves between the debriefs of one operator. `debriefs` is newest first (API
// order); "Précédent" goes back in time, "Suivant" forward.
const OperatorDebriefNav = ({ debriefs, currentId, onNavigate, formatDate }) => {
  const { t } = useTranslation();

  const currentIndex = debriefs.findIndex((d) => d.id === currentId);
  if (debriefs.length < 2 || currentIndex === -1) return null;

  const older = debriefs[currentIndex + 1];
  const newer = debriefs[currentIndex - 1];
  const position = debriefs.length - currentIndex;

  const describe = (debrief) => {
    const period = `${formatDate(debrief.period_start)} - ${formatDate(debrief.period_end)}`;
    const status = t(STATUS_LABELS[debrief.status] || STATUS_LABELS.draft);
    return `${period} · ${status}${debrief.archived ? ` · ${t("Archivé")}` : ""}`;
  };

  return (
    <div className="flex items-center gap-2 px-5 mt-1">
      <Button
        size="sm"
        variant="light"
        startContent={<FiChevronLeft size={14} />}
        isDisabled={!older}
        onClick={() => onNavigate(older.id)}
      >
        {t("Débrief précédent")}
      </Button>

      <Dropdown>
        <DropdownTrigger>
          <Button
            size="sm"
            variant="flat"
            endContent={<FiChevronDown size={14} />}
          >
            {t("Débrief {{position}} sur {{total}}", { position, total: debriefs.length })}
          </Button>
        </DropdownTrigger>
        <DropdownMenu
          aria-label={t("Débriefs de cet opérateur")}
          disallowEmptySelection
          selectionMode="single"
          selectedKeys={[currentId]}
          onAction={(key) => key !== currentId && onNavigate(key)}
          className="max-h-80 overflow-y-auto"
        >
          {debriefs.map((debrief) => (
            <DropdownItem key={debrief.id}>{describe(debrief)}</DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>

      <Button
        size="sm"
        variant="light"
        endContent={<FiChevronRight size={14} />}
        isDisabled={!newer}
        onClick={() => onNavigate(newer.id)}
      >
        {t("Débrief suivant")}
      </Button>
    </div>
  );
};

export default OperatorDebriefNav;
